import {
  Avatar,
  Box,
  Card,
  CardContent,
  Divider,
  Typography,
  Grid,
} from "@mui/material";

const CompanyDetailsCard = ({ company }) => {
  if (!company || typeof company !== "object") {
    return null;
  }

  const logo = company.companyImgLogo || "";
  const companyName = company.companyName || company.name || "Sin nombre";
  const companyId = company.id || "Sin ID";
  const companyRut = company.companyRut || company.rut || "Sin RUT";
  const companyRegion = company.companyRegion || "";
  const companyCity = company.companyCity || "";
  const companyAddress =
    company.companyAddress || company.address || "Sin dirección";
  const contactName =
    company.companyContacName || company.contactName || "Sin contacto";
  const contactEmail =
    company.companyContacEmail || company.email || "Sin email";
  const contactPhone =
    company.companyAdressPhone || company.phone || "Sin teléfono";

  const location =
    [companyRegion, companyCity].filter(Boolean).join(", ") || "Sin ubicación";

  return (
    <Card sx={{ p: 2, mb: 2, boxShadow: 3 }}>
      <CardContent>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={3}>
            <Avatar src={logo} sx={{ width: 80, height: 80 }} />
          </Grid>

          <Grid item xs={12} sm={9}>
            <Typography variant="h6">{companyName}</Typography>
            <Typography variant="h6">ID: {companyId}</Typography>
            <Typography color="textSecondary">{companyRut}</Typography>
            <Typography>{location}</Typography>
            <Typography>{companyAddress}</Typography>
            <Typography>Contacto: {contactName}</Typography>
            <Typography>Email: {contactEmail}</Typography>
            <Typography>Teléfono: {contactPhone}</Typography>
          </Grid>
        </Grid>
      </CardContent>

      <Divider />
    </Card>
  );
};

export default CompanyDetailsCard;
